export function mapEntries<T, U>(data: Record<string, T>, callback: (value: T, key: string) => U): Record<string, U> {
  return Object.fromEntries(Object.entries(data).map(([key, value]) => [key, callback(value, key)]))
}

export function filterEntries<T>(
  data: Record<string, T>,
  callback: (value: T, key: string) => boolean,
): Record<string, T> {
  return Object.fromEntries(Object.entries(data).filter(([key, value]) => callback(value, key)))
}
